import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleEditProjectMembersListingConfigurationRequest(
  state: State,
  { planzone }: Boundaries["editProjectMembersListingConfiguration"]["request"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToPending() }];
}

function handleEditProjectMembersListingConfigurationSuccess(
  state: State,
  { planzone }: Boundaries["editProjectMembersListingConfiguration"]["success"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToSuccess() }];
}

function handleEditProjectMembersListingConfigurationFailure(
  state: State,
  { planzone }: Boundaries["editProjectMembersListingConfiguration"]["failure"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToFailure() }];
}

const reduceState = createStateReducer(initialState, {
  [events.editProjectMembersListingConfigurationRequested]:
    handleEditProjectMembersListingConfigurationRequest,
  [events.editProjectMembersListingConfigurationSucceeded]:
    handleEditProjectMembersListingConfigurationSuccess,
  [events.editProjectMembersListingConfigurationFailed]:
    handleEditProjectMembersListingConfigurationFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
